export default __webpack_public_path__ + "fan.png?2f884222a003f57f290be4f4d2c1320e";